import React, { useState, useEffect, useRef } from "react";
import Header from "../../../Header";
import Pagination from "react-js-pagination";
import RsuiteChecker from "../../RsuiteChecker";
import LiveStreamInfoList from "./LiveStreamInfoList";
import { ToastContainer } from "react-toastify";
import Confirm from "../modals/Confirm";
import StopLiveStreamConfirm from "../modals/StopLiveStreamConfirm";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
const environmentNames = [
	{ value: "Dev", id: "dev" },
	{ value: "Staging", id: "staging" },
	{ value: "Pre Prod", id: "preprod" },
	{ value: "Prod", id: "prod" },
];
const environmentNamesPlayout = [
	{ value: "Dev", id: "https://embedplayout-asthu.muvistaging.com" },
	{ value: "Staging", id: "https://embedplayout-edocent.muvistaging.com" },
	{ value: "Pre Prod", id: "https://embedplayout-idogic.muvistaging.com" },
	{ value: "Prod", id: "https://embedplayout.muvi.com" },
];
const LiveStreamInfo = () => {
	const hasMounted = useRef(false);
	const [livestreamData, setLivestreamData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setperPage] = useState(20);
	const [totalCount, setTotalCount] = useState(0);
	const [offSet, setoffSet] = useState(0);
	const [serverMuviLive, setServerMuviLive] = useState("prod");
	const [serverMuviPlayout, setServerMuviPlayout] = useState("prod");
	const [confirmModalData, setConfirmModalData] = useState(null);
	const [stopLiveStreamModalData, setStopLiveStreamModalData] = useState(null);
	const [isShowLiveServer, setIsShowLiveServer] = useState(true);
	const [isShowPlayoutServer, setIsShowPlayoutServer] = useState(false);
	//Muvi user id to return login url
	const [muviUserId, setMuviUserId] = useState(0);

	function decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	function decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}

	function handlePageChange(pageNumber = 1) {
		setCurrentPage(pageNumber);
		//getCustomerData(pageNumber);
	}

	const handleClickMuviLive = () => {
		setIsShowLiveServer(true);
		setIsShowPlayoutServer(false);
		const requestBody = { key: "live" };
		// Add the server parameter to the request body if it's not null
		requestBody.server = serverMuviLive;
		fetch(`${process.env.REACT_APP_CRM}/muvi6/get-livestream-info`, {
			method: "POST",
			body: JSON.stringify(requestBody),
		})
			.then((res) => {
				if (!res.ok) {
					throw new Error(`HTTP error! Status: ${res.status}`);
				}
				return res.json();
			})
			.then((data) => {
				if (data.code == 200) {
					setLoading(false);
					setLivestreamData(data.data || []);
					setTotalCount(data.data.length);
				} else {
					setLoading(false);
					setLivestreamData([]);
					setTotalCount(0);
					throw new Error(`API error! Code: ${data.code}`);
				}
			})
			.catch((error) => {
				console.error("Fetch error:", error.message);
				// Handle fetch error
			});
	};
	const handleClickMuviPlayout = () => {
		setIsShowPlayoutServer(true);
		setIsShowLiveServer(false);
		const requestBody = { key: "playout" };
		// Add the search parameter to the request body if it's not null
		requestBody.server = serverMuviPlayout;
		fetch(`${process.env.REACT_APP_CRM}/muvi6/get-livestream-info`, {
			method: "POST",
			body: JSON.stringify(requestBody),
		})
			.then((res) => {
				if (!res.ok) {
					throw new Error(`HTTP error! Status: ${res.status}`);
				}
				return res.json();
			})
			.then((data) => {
				if (data.code == 200) {
					setLoading(false);
					setLivestreamData(data.data || []);
					setTotalCount(data.data.length);
				} else {
					setLoading(false);
					setLivestreamData([]);
					setTotalCount(0);
					throw new Error(`API error! Code: ${data.code}`);
				}
			})
			.catch((error) => {
				console.error("Fetch error:", error.message);
				// Handle fetch error
			});
	};

	// Handle input change
	const changeMuviLiveServerHandler = (value, key) => {
		setServerMuviLive(value);
	};
	const changeMuviPlayoutServerHandler = (value, key) => {
		setServerMuviPlayout(value);
	};

	//CTA Related Work Start
	const handleClickConfirmModal = (confirmText, product_key, user_uuid, type) => {
		let server = type == "live" ? serverMuviLive : serverMuviPlayout;
		setConfirmModalData({
			confirmText,
			product_key,
			user_uuid,
			type,
			server,
			muviUserId,
		});
		// const activeTab = document.querySelector(".tab-pane .active");
		// activeTab.innerHTML = "Hello World";
		const confirmModal = document.getElementById("confirmModal");
		// Open the modal
		confirmModal.classList.add("show");
		confirmModal.style.display = "block";
	};
	const handleClickStopLiveStreamConfirmModal = (confirmText, product_key, user_uuid, livestream_uuid, type) => {
		let server = type == "live" ? serverMuviLive : serverMuviPlayout;
		setStopLiveStreamModalData({
			confirmText,
			product_key,
			user_uuid,
			livestream_uuid,
			type,
			server,
		});

		const stopLiveStreamConfirmModal = document.getElementById("stopLiveStreamConfirmModal");
		// Open the modal
		stopLiveStreamConfirmModal.classList.add("show");
		stopLiveStreamConfirmModal.style.display = "block";
	};
	useEffect(() => {
		if (hasMounted.current) {
			handleClickMuviPlayout();
		} else {
			hasMounted.current = true;
		}
	}, [serverMuviPlayout]);
	useEffect(() => {
		handleClickMuviLive();
	}, [serverMuviLive]);
	useEffect(() => {
		//Getting Muvi userid to return login url as a parameter
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? decrypt(localStorage.getItem("encdata"), 0) : "";
		setMuviUserId(localdata && localdata.user_id);
	}, []);
	return (
		<div>
			<Header brecum_name="Stream Info" brecum_page="Stream Info" />
			<ToastContainer />
			<div className="right_col">
				<div className="customer-wrap">
					<section className="customer">
						<div id="exTab1" className="container">
							<ul className="nav nav-pills nav-tabs">
								<li className="active">
									<a href="#MuviLive" class="tab" data-toggle="tab" onClick={() => handleClickMuviLive()}>
										Muvi Live
									</a>
								</li>
								<li className="">
									<a href="#MuviPlayout" class="tab" data-toggle="tab" onClick={() => handleClickMuviPlayout()}>
										Muvi Playout
									</a>
								</li>
								<li className="float-right" style={{ width: "30%" }}>
									<div className="row" style={{ margin: "0rem .5rem 1rem" }}>
										{isShowLiveServer && (
											<div className="col-sm-12 col-md-12 col-lg-12">
												<div className="input-box">
													{/* <label className="input-label">Live Server</label> */}
													<RsuiteChecker
														data={
															environmentNames.map((item) => ({
																value: item.value,
																id: item.id,
															})) || []
														}
														val={serverMuviLive}
														select={true}
														onChange={(evt) => changeMuviLiveServerHandler(evt, "key")}
														field_name="server_name"
													/>
												</div>
											</div>
										)}

										{isShowPlayoutServer && (
											<div className="col-sm-12 col-md-12 col-lg-12">
												<div className="input-box">
													{/* <label className="input-label">Playout Server </label> */}
													<RsuiteChecker
														data={
															environmentNames.map((item) => ({
																value: item.value,
																id: item.id,
															})) || []
														}
														val={serverMuviPlayout}
														select={true}
														onChange={(evt) => changeMuviPlayoutServerHandler(evt, "key")}
														field_name="server_name"
													/>
												</div>
											</div>
										)}
									</div>
								</li>
							</ul>
							<div className="tab-content clearfix">
								<div className="tab-pane active" id="MuviLive">
									<div className="row">
										{/* List */}

										<div className="body-content">
											<div className="table-wrap" style={{ padding: "5px", minHeight: "60vh" }}>
												<LiveStreamInfoList
													livestreamData={livestreamData}
													totalCount={totalCount}
													loading={loading}
													handleClickConfirmModal={handleClickConfirmModal}
													handleClickStopLiveStreamConfirmModal={
														handleClickStopLiveStreamConfirmModal
													}
													type="live"
												/>
											</div>
										</div>

										{/* Pagination */}
										{totalCount > 0 ? (
											<div
												className="d-flex mu-pagination justify-content-between align-items-center"
												aria-label="Page navigation example"
											>
												<div className="txt-dark">
													Showing {offSet + 1 + " - " + (offSet + perPage)} of {totalCount}
												</div>
												<div className="mu-pagination">
													<Pagination
														activePage={currentPage}
														itemsCountPerPage={20}
														totalItemsCount={totalCount}
														pageRangeDisplayed={5}
														itemClass="page-item"
														linkClass="page-link"
														onChange={handlePageChange}
													/>
												</div>
											</div>
										) : (
											""
										)}
									</div>
								</div>
								<div className="tab-pane" id="MuviPlayout">
									<div className="row">
										{/* Customer List */}
										<div className="body-content">
											<div className="table-wrap" style={{ padding: "5px", minHeight: "60vh" }}>
												<LiveStreamInfoList
													livestreamData={livestreamData}
													totalCount={totalCount}
													loading={loading}
													handleClickConfirmModal={handleClickConfirmModal}
													handleClickStopLiveStreamConfirmModal={
														handleClickStopLiveStreamConfirmModal
													}
													type="playout"
												/>
											</div>
										</div>

										{/* Pagination */}
										{totalCount > 0 ? (
											<div
												className="d-flex mu-pagination justify-content-between align-items-center"
												aria-label="Page navigation example"
											>
												<div className="txt-dark">
													Showing {offSet + 1 + " - " + (offSet + perPage)} of {totalCount}
												</div>
												<div className="mu-pagination">
													<Pagination
														activePage={currentPage}
														itemsCountPerPage={20}
														totalItemsCount={totalCount}
														pageRangeDisplayed={5}
														itemClass="page-item"
														linkClass="page-link"
														onChange={handlePageChange}
													/>
												</div>
											</div>
										) : (
											""
										)}
									</div>
								</div>
								{/*CTA Modals */}
								<Confirm data={confirmModalData} />
								<StopLiveStreamConfirm data={stopLiveStreamModalData} />
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>
	);
};
const styleObj = {
	intra_col_15: {
		width: "15%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_20: {
		width: "20%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_2: {
		width: "2%",
	},
};
export default LiveStreamInfo;



// WEBPACK FOOTER //
// ./src/components/crm/livestream/LiveStreamInfo.js